import React, { useEffect, useState } from "react";
import { getCommonConfig, updateCommonConfig } from "@/services/commonconfig";

const NotificationConfig: React.FC = () => {
  const [enabled, setEnabled] = useState(true);
  const [initial, setInitial] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await getCommonConfig();
    setEnabled(res.NotificationIcon);
    setInitial(JSON.stringify(res));
  };

  const hasChanges =
    initial !== "" &&
    enabled !== JSON.parse(initial).NotificationIcon;

  const handleSave = async () => {
    setSaving(true);

    const parsed = JSON.parse(initial);

    await updateCommonConfig({
      LogoutTime: parsed.LogoutTime,
      WarningTime: parsed.WarningTime,
      InactiveDays: parsed.InactiveDays,
      TourIcon: parsed.TourIcon,
      NotificationIcon: enabled,
      LanguageSwitchIcon: parsed.LanguageSwitchIcon,
    });

    setInitial(JSON.stringify({ ...parsed, NotificationIcon: enabled }));

    setSaving(false);
  };

  const handleCancel = () => {
    setEnabled(JSON.parse(initial).NotificationIcon);
  };

  return (
    <div className="border border-gray-200 rounded-md bg-[#fbfaf7] p-3 space-y-3">

      <div className="flex items-center gap-4 text-xs">
        <span className="w-40 text-gray-700">Notification Icon</span>

        <div className="flex border border-gray-300 rounded overflow-hidden">
          <button
            className={`px-3 py-1 text-xs ${
              enabled ? "bg-orange-500 text-white" : "bg-gray-100 text-gray-600"
            }`}
            onClick={() => setEnabled(true)}
          >
            Show
          </button>
          <button
            className={`px-3 py-1 text-xs ${
              !enabled ? "bg-orange-500 text-white" : "bg-gray-100 text-gray-600"
            }`}
            onClick={() => setEnabled(false)}
          >
            Hide
          </button>
        </div>
      </div>

      <div className="flex justify-end gap-2 items-center">

        {hasChanges && (
          <div className="text-orange-600 border border-orange-300 bg-orange-50 px-2 py-0.5 rounded text-xs">
            Unsaved
          </div>
        )}

        <button
          className="bg-[#e7e5e0] px-3 py-1 rounded text-xs"
          onClick={handleCancel}
          disabled={!hasChanges}
        >
          Cancel
        </button>

        <button
          className="bg-orange-500 text-white px-3 py-1 rounded text-xs"
          onClick={handleSave}
          disabled={!hasChanges || saving}
        >
          {saving ? "Saving..." : "Save"}
        </button>

      </div>

    </div>
  );
};

export default NotificationConfig;
